import { Component, OnInit, output, signal } from '@angular/core';
import { TagComponent } from '../../../../../shared/components/tag/tag.component';
import { GetRideStatusSeverity } from '../../../../../shared/enums/rideStatusType';
import { DriverMapRideDto } from '../../../interfaces/driver-map-ride';
import { UserRole } from '../../../../../../app/core/auth/enums/userRoles';

@Component({
  selector: 'app-driver-tooltip',
  standalone: true,
  imports: [TagComponent],
  templateUrl: './driver-tooltip.component.html',
  styleUrl: './driver-tooltip.component.scss',
})
export class DriverTooltipComponent implements OnInit {
  driver = signal<DriverMapRideDto | null>(null);
  closed = output<void>();
  statusSeverityClass = signal<string>('');
  currentRole = (localStorage.getItem('role') ?? '').toLowerCase();
  userRole = UserRole;

  ngOnInit() {
    this.setStatusSeverityClass();
  }

  setStatusSeverityClass() {
    const isAttention: boolean = this.driver()?.is_attention ?? false;
    const statusSeverity = GetRideStatusSeverity(this.driver()?.ride_status ?? 'Schedule', isAttention);
    if (statusSeverity == 'secondary') {
      this.statusSeverityClass.set(`icon-light-bg`);
      return;
    }
    this.statusSeverityClass.set(`icon-${statusSeverity}-bg`);
  }

  close() {
    this.closed.emit();
  }
}
